<div class="container">
  <div class="booking-body">
    <ng-container *ngIf="isMobile">
      <ng-container *ngTemplateOutlet="flightSectors"></ng-container>
    </ng-container>

    <ng-container class="body-flights-booking">
      <form *ngIf="user" [formGroup]="bookingFlightsForm"
        class="booking-form-info">
        <section class="pax-section-cont">
          <ng-container 
            *ngTemplateOutlet="passengerTitleBlock">
          </ng-container>
          <ng-container *ngFor="let passengerUI of passengerListUI$ | async; index as i">
            <app-pax-section
              [frequentFlyerPrograms]="frequentFlyerPrograms$ | async"
              [validator]="airValidation"
              [countries]="countries$ | async | countriesVm"
              [travelerType]="passengerUI.TravelerType"
              [listUILength]="passengerListUILength$ | async"
              [travelerInfoType]="passengerUI.TravelerInfoType"
              [paxTravelers]="travelers$ | async | travelerListVm : passengerUI.TravelerType : passengerUII(i) : startDate | async"
              [ordinalKey]="passengerUI.OrdinalKey"
              [defaultData]="passengerUI.defaultData"
              [form]="bookingFlightsForm"
              [user]="user"
              [showFrequentFlyer]="true"
              [isAnInternationalTrip]="isAnInternationalTrip$ | async"
              [isSubmittedSuccess]="isSubmittedSuccess"
              [isSubmitted]="isSubmitted"
              [travelerNumber]="i"
              [isMobile]="isMobile"
              [businessRules]="businessRules$ | async"
              [productCode]="airlineCode"
              [productProvider]="airlineProvider"
              (createLoyalty)="createLoyalty($event, i)"
              (selectLoyalty)="selectLoyalty($event, i)"
              (removeLoyalty)="deleteLoyalty($event, i)"
              (updateLoyalty)="updateLoyalty($event, i)"
              (selectPax)="selectTravelerPax($event, i)"
              (removePax)="deleteTravelerPax($event, i)"
              (createPax)="createTravelerPax($event, bookingFlightsForm, { id: i, TravelerInfoType: passengerUI.TravelerInfoType }, startDate)"
              (updatePax)="updateTravelerPax($event, bookingFlightsForm, { id: i, TravelerInfoType: passengerUI.TravelerInfoType })"
              (amplitudeEvent)="trackBookingAmplitudeEvent($event, travelerBookingProvider)"
              (removeDefaultPax)="removeDefaultPax($event)">
            </app-pax-section>
          </ng-container>
          <app-booking-lastname-alert
            [passengers]="passengerListUI$ | async"
            [hasAirValidation]="hasAirValidation">
          </app-booking-lastname-alert>
        </section>

        <ng-container *ngIf="paxSectionReady">
          <section *ngIf="activeBillingModule" #sectionBillingRef>
            <ng-container *ngTemplateOutlet="billingSectionTemplate"></ng-container>
          </section>
          <section class="contact-info-cont" #sectionContactDetails>
            <app-contact-section
              [form]="bookingFlightsForm"
              [isSubmitted]="isSubmitted"
              [isMobile]="isMobile"
              [user]="user">
            </app-contact-section>
          </section>
          <section>
            <app-policies-detail
              [policiesType]="policiesType"
              [isMobile]="isMobile"
              [airValidation]="airValidationBySector?.AirValidateResponse"
              [showFreeCancellation]="freeCancellationValidate"
              [airTermsBySector]="true"
              [isBookingView]="true">
            </app-policies-detail>
          </section>
          <app-fare-info [textFare]="airValidation?.TripOption?.TextFare"></app-fare-info>
          <section class="content-banner">
            <ng-container *ngTemplateOutlet="chubbBookingBanner"></ng-container>
          </section>
          <section class="terms-cont" #sectionPaymentDetail>
            <app-payment-detail
              [passengerArrangement]="passengerArrangementsState$ | async"
              [price]="airValidationBySector?.TotalPrice"
              [currencyCode]="airValidation?.TripOption?.Price?.CurrencyCode"
              [isRappiProBrandig]="isRappiProBrandig$ | async"
              [isMobile]="isMobile">
            </app-payment-detail>
          </section>
          <section class="terms-cont" #sectionTermsRef>
            <app-terms-and-conditions
              [form]="bookingFlightsForm"
              [isSubmitted]="isSubmitted">
            </app-terms-and-conditions>
          </section>
        </ng-container>

        <section *ngIf="applyConversion$ | async">
          <app-exchange-rate-info [conversionRate]="conversionRate$ | async">
          </app-exchange-rate-info>
        </section>

        <section *ngIf="activeCallSupportModule">
          <app-support-info></app-support-info>
        </section>

        <app-btn-go-to-pay
          [isMobile]="isMobile"
          [disabled]="(bookingReady$ | async) === false"
          [isLoadingBooking]="isLoadingBookingDelay"
          [applyConversion]="applyConversion$ | async"
          [conversionRate]="conversionRate$ | async"
          [finalPrice]="airValidationBySector?.TotalPrice?.Total"
          [currencyCode]="airValidation?.TripOption?.Price?.CurrencyCode"
          [productReference]="firstTrip?.ProductReference"
          (goToPay)="submitBookingOptions($event)">
        </app-btn-go-to-pay>
      </form>
    </ng-container>
  </div>
</div>

<ng-template #flightSectors>
  <app-alert-message 
    *ngIf="showBySectorItineraryInfo"
    [text]="'BOOKING_MODULE.BY_SECTOR_ITINERARY_INFO' | transloco"
  >
  </app-alert-message>

  <ng-container *ngFor="let tripOption of airValidationBySector.AirValidateResponse; let i = index; let first = first; let last = last;">
    <app-travel-segment-detail
      [isMobile]="isMobile"
      [upsellLoading]="false" 
      [showUpsell]="false"
      [upsellSelected]="null"
      [fareFamilies]="fareFamilies(tripOption)"
      [baggage]="baggage(tripOption)"
      [validationVm]="tripOption | airValidationVm"
      [summaryProvider]="flightSummaryProvider"
      [isFlightBySector]="true"
      [index]="i"
      [isFirst]="first"
      [isLast]="last"
      [isInternational]="isAnInternationalTrip$ | async"
      (showFlightDetail)="showFlightDetail($event)">
    </app-travel-segment-detail>
  </ng-container>
</ng-template>

<ng-template #billingSectionTemplate>
  <ng-container *ngIf="billingModuleIsOptional; else billingModuleTemplate">
    <ng-container *ngTemplateOutlet="optinalBillingModuletemplate"></ng-container>
  </ng-container>

  <ng-template #optinalBillingModuletemplate>
    <app-optional-billing-box
      [showBillingModule]="showBillingModule"
      (setShowBillingModule)="setShowBillingModule($event)"
    >
    </app-optional-billing-box>
    <ng-container *ngTemplateOutlet="billingModuleTemplate; context: { hiddenHeader: true }"></ng-container>
  </ng-template>

  <ng-template #billingModuleTemplate let-hiddenHeader="hiddenHeader">
    <ng-container *ngIf="showBillingModuleData">
      <app-billing
        [isSubmitted]="isSubmitted"
        [bookingForm]="bookingFlightsForm"
        [countries]="countries$ | async | countriesVm"
        [cities]="cities$ | async"
        [user]="user"
        [showHeaderInfo]="!hiddenHeader"
        [isMobile]="isMobile">
      </app-billing>
    </ng-container>
  </ng-template>
</ng-template>

<ng-template #chubbBookingBanner let-isPayment="isPayment">
  <ng-container *ngIf="!!hasTravelerInfoList">
    <app-chubb-booking-banner
      [bookingType]="travelerBookingProvider"
      [days]="1"
      [travelers]="travelerInfoList?.length"
      [isInternationalTrip]="isAnInternationalTrip$ | async"
      [isPayment]="!!isPayment"
      [assistanceInfo]="assistanceSearchInfo$ | async"
      [isActivateFreeChubbAssistance]="isActivateFreeChubbAssistance$ | async"
      [isPrimeUser]="isPrimeUser$ | async"
      (showPaymentOfferDetails)="setShowAssistanceDetails(true)">
    </app-chubb-booking-banner>
  </ng-container>
</ng-template>

<app-travel-assistance
  [bookingType]="travelerBookingProvider"
  [isMobile]="isMobile"
  [showAssistanceInfo]="showAssistanceInfo$ | async"
  [assistanceInfo]="assistanceSearchInfo$ | async"
  [totalPrice]="airValidationBySector?.TotalPrice?.Total"
  [isLoading]="isLoadingBookingDelay"
  [showDetailInfo]="showAssistanceDetails$ | async"
  (amplitudeTrigger)="trackBookingAmplitudeEvent($event, travelerBookingProvider)"
  (hiddenAssistanceDetails)="setShowAssistanceDetails(false)"
  (payButtonEvent)="submitBookingOptionsByAssistance($event)"
  (exitEvent)="closeAssistanceInfo()"
  >
  <ng-container assistanceBanner>
    <ng-container *ngTemplateOutlet="chubbBookingBanner; context: { isPayment: true }"></ng-container>
  </ng-container>
</app-travel-assistance>